import React, {useContext} from 'react'
import {Redirect} from "react-router-dom";
import {FirebaseAuthContext} from "../../firebase/FirebaseAuthProvider";
import LoadingProgressIndication from "../../elements/progress/loading/LoadingProgressIndication";
import {useIntl} from "react-intl";


const AuthorizationGate = () => {
    const {signedInUserAuthCompleted, signedInUserRole, signedInUserEmailVerified} = useContext(FirebaseAuthContext)

    // Internationalization for simple strings
    const intl = useIntl();

    // Only do the routing in case the user is fully authenticated (i.e. all data from the token is stored in the state)
    if (signedInUserAuthCompleted) {
        if (!signedInUserEmailVerified) {
            return <Redirect to={"/waitingForEmailVerification"}/>;
        }

        // Administrator-roles dashboard
        if (signedInUserEmailVerified && ['admin', 'contentCreator', 'organizer'].includes(signedInUserRole)) {
            return <Redirect to={"/admin/dashboard"}/>;
        }

        // Player-role dashboard
        if (signedInUserEmailVerified && signedInUserRole === 'player') {
            return <Redirect to={"/game/dashboard"}/>;
        }
    }

    /*
    Current user already retrieved (i.e. authentication took place), but waiting for the user roles
    to be loaded in the FirebaseAuthProvider (as this is async). In this case no redirect must be done,
    because otherwise the pages would play ping-pong.
    This constellation can only happen in case the user signs-in at the first time, as the initial role
    is automatically set. For all subsequent logins the current user and roles are loaded after login.
     */

    return <LoadingProgressIndication text={intl.formatMessage({
        id: 'app.users.messages.accountPreparation.progress',
        defaultMessage: 'Your account is being prepared...'
    })}/>
}

export default AuthorizationGate
